import React from "react";
import DoctorRegForm from "./DoctorRegForm";
import DoctorList from "./DoctorList";

const DoctorManagement = () => {
  return (
    <>
      <DoctorRegForm />
      <DoctorList />
    </>
  );
};

export default DoctorManagement;
